import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ThemeLayoutRoutingModule } from './theme-layout-routing.module';
import { HeaderComponent } from './header/header.component';
import { FooterComponent } from './footer/footer.component';
import { MainLayoutComponent } from './main-layout/main-layout.component';
import { MatMenuModule } from '@angular/material/menu';
import { MatButtonModule } from '@angular/material/button';

@NgModule({
  declarations: [HeaderComponent, FooterComponent, MainLayoutComponent],
  imports: [
    CommonModule,
    ThemeLayoutRoutingModule,
    MatMenuModule,
    MatButtonModule
  ]
})
export class ThemeLayoutModule { }
